var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('generic-view',{attrs:{"title":"Delivery Addresses (Users, and Checkin Stations)","entity_name":"deliveryAddress","headers":_vm.headers,"show_excel":true,"show_print":true,"icon":"mdi-pin-outline"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }